/**
 * Extrai o primeiro link que contêm ou não contêm os relacionamentos indicados
 * no critério.
 *
 * @links {Array}
 *    A coleção de links investigados.
 * @criteria {String|Array|Object}
 *    O nome do relacionamento;
 *    Ou um array de relacionamentos;
 *    Ou um objeto contendo os relacionamentos na forma:
 *      { exact: [ ... ] }
 *      Neste caso somente links que declarem todos estes relacionamentos e
 *      nenhum outro são retornados;
 *    Ou um objeto contendo os relacionamentos na forma:
 *      {
 *        includes: [ ... ],
 *        excludes: [ ... ]
 *      }
 *      Neste caso são retornados os links que contenham os relacionamentos
 *      incluídos e não contenham os relacionamentos excluídos.
 */
export function findRel(links, criteria) {
  return findRels(links, criteria)[0]
}

/**
 * Extrai os links que contêm ou não contêm os relacionamentos indicados
 * not critério.
 *
 * @links {Array}
 *    A coleção de links investigados.
 * @criteria {String|Array|Object}
 *    O nome do relacionamento;
 *    Ou um array de relacionamentos;
 *    Ou um objeto contendo os relacionamentos na forma:
 *      { exact: [ ... ] }
 *      Neste caso somente links que declarem todos estes relacionamentos e
 *      nenhum outro são retornados;
 *    Ou um objeto contendo os relacionamentos na forma:
 *      {
 *        includes: [ ... ],
 *        excludes: [ ... ]
 *      }
 *      Neste caso são retornados os links que contenham os relacionamentos
 *      incluídos e não contenham os relacionamentos excluídos.
 */
export function findRels(links, criteria) {
  if (!links) return []
  if (!Array.isArray(links)) links = [ links ]
  if (!links?.length) return []

  let exact = []
  let includes = []
  let excludes = []

  if (typeof criteria === 'string') {
    includes = [criteria]
  } else if (Array.isArray(criteria)) {
    includes = criteria
  } else if (criteria?.exact) {
    exact = getArray(criteria.exact)
  } else {
    includes = getArray(criteria?.includes)
    excludes = getArray(criteria?.excludes)
  }

  let foundLinks = links.filter(link => {
    if (!link?.rel?.length)
      return false

    if (exact.length)
      return containsExact(link.rel, exact)

    if (includes.length && !containsAll(link.rel, includes))
      return false

    if (excludes.length && containsAny(link.rel, excludes))
      return false

    return true
  })

  return foundLinks
}

/**
 * Determina se o link não contém qualquer relacionamento definido.
 *
 * @links {Array}
 *    A coleção de links investigados.
 */
export function hasNoRels(links) {
  if (!links) return true

  if (!Array.isArray(links)) links = [ links ]
  if (!links?.length) return true

  // Retornar verdadeiro se todos os links ou não contêm rel ou contém rel vazio.
  return links.every(link => !link?.rel?.length)
}

/**
 * Determina se o link contêm ou não os relacionamentos indicados
 * not critério.
 *
 * @links {Array}
 *    A coleção de links investigados.
 * @criteria {String|Array|Object}
 *    O nome do relacionamento;
 *    Ou um array de relacionamentos;
 *    Ou um objeto contendo os relacionamentos na forma:
 *      { exact: [ ... ] }
 *      Neste caso somente links que declarem todos estes relacionamentos e
 *      nenhum outro são retornados;
 *    Ou um objeto contendo os relacionamentos na forma:
 *      {
 *        includes: [ ... ],
 *        excludes: [ ... ]
 *      }
 *      Neste caso são retornados os links que contenham os relacionamentos
 *      incluídos e não contenham os relacionamentos excluídos.
 */
export function hasRel(links, criteria) {
  if (!links) return false
  if (!Array.isArray(links)) links = [ links ]
  if (!links?.length) return false

  let exact = []
  let includes = []
  let excludes = []

  if (typeof criteria === 'string') {
    includes = [criteria]
  } else if (Array.isArray(criteria)) {
    includes = criteria
  } else if (criteria?.exact) {
    exact = getArray(criteria.exact)
  } else {
    includes = getArray(criteria?.includes)
    excludes = getArray(criteria?.excludes)
  }

  // TODO: poderia ser melhorado para evitar atravessar o array apenas para saber se existe um item...
  let foundLinks = links.filter(link => {
    if (!link?.rel?.length)
      return false

    if (exact.length)
      return containsExact(link.rel, exact)

    if (includes.length && !containsAll(link.rel, includes))
      return false

    if (excludes.length && containsAny(link.rel, excludes))
      return false

    return true
  })

  return !!foundLinks.length
}

function getArray(target) {
  if (!target) return []
  return Array.isArray(target) ? target : [ target ]
}

function containsAll(array, items) {
  return items.every(x => array.includes(x));
}

function containsAny(array, items) {
  return items.some(x => array.includes(x));
}

function containsExact(array, items) {
  return !array.some(x => !items.includes(x))
    && !items.some(x => !array.includes(x))
}
